import { render, staticRenderFns } from "./TeamMemberBox.vue?vue&type=template&id=3b16b8ed&"
import script from "./TeamMemberBox.vue?vue&type=script&lang=js&"
export * from "./TeamMemberBox.vue?vue&type=script&lang=js&"
import style0 from "./TeamMemberBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports